import React from "react";

import { Box, Theme } from "@mui/material";
import { Outlet } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import NavLink from "@/components/NavLink";

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    marginTop: 20,
  },
  navLinkContainer: {
    display: "inline-flex",
    marginInline: 20,
  },
  link: {
    color: "#8EAFA9",
    display: "block",
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: "-0.5px",
    padding: theme.spacing(1, 3),
    textDecoration: "none",
  },
  activeLink: {
    color: "#26C9A7",
    borderBottom: "4px solid transparent",
    borderBottomColor: theme.palette.primary.main,
  },
}));

const ReportsLinks: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.navLinkContainer}>
        <NavLink
          to="meal-ratings"
          className={classes.link}
          activeClassName={classes.activeLink}
        >
          Meal Ratings
        </NavLink>
      </Box>
      <Outlet />
    </Box>
  );
};

export default ReportsLinks;
